import React from 'react'



import LoanApplication from "./loanApplication-page/LoanApplication"
const Loan = () => {
  return (
    <>
      <LoanApplication />
    </>
  )
}

export default Loan